import { render, staticRenderFns } from "./brandInformationList.vue?vue&type=template&id=f05c7414&scoped=true&"
import script from "./brandInformationList.vue?vue&type=script&lang=js&"
export * from "./brandInformationList.vue?vue&type=script&lang=js&"
import style0 from "./brandInformationList.vue?vue&type=style&index=0&id=f05c7414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05c7414",
  null
  
)

export default component.exports